module.exports = __webpack_public_path__ + "static/media/duration.174d6acd.svg";